import { render, staticRenderFns } from "./WIcon.vue?vue&type=template&id=a536c5cc"
import script from "./WIcon.vue?vue&type=script&lang=js"
export * from "./WIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports